export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-primary-100/50 blur-3xl"></div>
        <div className="absolute -bottom-20 -left-20 w-[400px] h-[400px] rounded-full bg-accent-100/40 blur-3xl"></div>
        <div className="absolute top-1/3 left-1/4 w-[300px] h-[300px] rounded-full bg-secondary-100/30 blur-3xl"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-4">
              <i className="ri-fire-line text-sm"></i>
              <span>每日更新·热门连载</span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-3">
              樱花漫画 · 韩漫日漫国漫免费全集下拉式阅读平台
            </h1>

            <p className="text-lg md:text-xl text-primary-600 font-heading mb-6">
              追更连载，收藏佳作，发现你的下一部心头好
            </p>

            <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              樱花漫画网汇聚海量韩漫、日漫、国漫资源，全部漫画均可免费全集下拉式阅读，无需翻页等待。每日更新热门连载，智能推荐好看漫画，支持收藏与追更提醒，一站式满足漫画爱好者的阅读需求。无论是热血少年、浪漫恋爱还是悬疑推理，这里都有属于你的精神食粮。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center">
                  <i className="ri-book-open-line text-lg text-accent-600"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg font-bold text-foreground-900">30,000+</div>
                  <div className="text-xs text-foreground-500">漫画作品收录</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center">
                  <i className="ri-timer-line text-lg text-secondary-600"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg font-bold text-foreground-900">每日更新</div>
                  <div className="text-xs text-foreground-500">追更永不断档</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center">
                  <i className="ri-shield-check-line text-lg text-primary-600"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg font-bold text-foreground-900">全本免费</div>
                  <div className="text-xs text-foreground-500">下拉式畅快阅读</div>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-compass-3-line"></i>
                开始探索漫画
              </a>
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full border-2 border-foreground-200 text-foreground-700 font-semibold text-sm hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-trophy-line"></i>
                查看热门排行
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/5] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20vibrant%20artistic%20manga%20reading%20scene%20with%20warm%20red%20and%20soft%20cream%20tones%2C%20stylized%20comic%20panels%20floating%20in%20the%20air%2C%20a%20cozy%20reading%20nook%20with%20a%20tablet%20displaying%20colorful%20manga%20art%2C%20cherry%20blossom%20petals%20drifting%20gently%2C%20warm%20ambient%20lighting%2C%20artistic%20illustration%20style%2C%20dreamy%20atmosphere%2C%20sakura%20theme%2C%20clean%20composition%2C%20modern%20aesthetic%2C%20high%20detail%2C%20editorial%20quality&width=960&height=1200&seq=hero-manga-01&orientation=portrait"
                alt="樱花漫画阅读场景 - 海量韩漫日漫国漫免费全集下拉式阅读"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/30 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 bg-background-50/90 backdrop-blur-sm rounded-xl p-3 flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-cloud-line text-primary-600"></i>
                </div>
                <div>
                  <div className="text-xs font-semibold text-foreground-900">下拉式阅读</div>
                  <div className="text-xs text-foreground-500">一滑到底，畅快追漫</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}